var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import Common_Shimmer from "@frameworks/shared-library/components/common_shimmer";
import "@frameworks/shared-library/stylesheets/components/GenericTableShimmer/GenericTableShimmer.scss";
/**
 * This component renders a shimmer in table format until the next set of Mutual funds are fetched on load more click.
 *
 * @param {number} rowCount - Shimmer table row count
 * @param {number} columnCount - Shimmer table column count
 * @param {string} columnsWidthClass - className to set the width of each column containing the shimmer use grid-auto-column. Eg: grid-auto-columns: 2fr 1fr 1fr 1fr 1fr 1fr;
 * @param {string} parentClassName - className to override the styles from parent component.
 *
 * @returns {}
 */
var GenericTableShimmer = function (props) {
    var _a;
    var _b = props.rowCount, rowCount = _b === void 0 ? 4 : _b, _c = props.columnCount, columnCount = _c === void 0 ? 4 : _c;
    var _d = __read(useState([]), 2), rowComp = _d[0], setRowsComp = _d[1];
    var generateShimmer = function () {
        setRowsComp(generateRows());
    };
    var generateColumns = function () {
        return Array.from({ length: columnCount }, function (_, colIndex) { return (React.createElement("td", { key: colIndex },
            React.createElement(Common_Shimmer, { number: 1 }))); });
    };
    var generateRows = function () {
        return Array.from({ length: rowCount }, function (_, rowIndex) {
            var _a;
            return (React.createElement("tr", { key: rowIndex, className: (_a = props === null || props === void 0 ? void 0 : props.columnsWidthClass) !== null && _a !== void 0 ? _a : "" }, generateColumns()));
        });
    };
    React.useEffect(function () {
        generateShimmer();
    }, []);
    return (React.createElement("div", { className: "primary-generic-table-shimmer-container ".concat((_a = props.parentClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement("table", { className: "mf-tabel-shimmer" },
            React.createElement("tbody", null, rowComp))));
};
export default GenericTableShimmer;
